/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { Segment } from 'semantic-ui-react';
import { useSelector } from 'react-redux';

import { getConsultById } from '../../../../../selectors/webChat/consults';

import MenuOptions from './MenuOptions';
import BubbleMenu from './BubbleMenu';
import UserStatus from './UserStatus';

const MessageHeader = props => {
  const {
    conversationActive,
    contextMenu,
    doctor,
    openFinishConsult,
    onClickBubble,
    isMinimize,
    openPrescriptionModal,
    openReferralMemo,
    openMemoRandum,
    openPOS,
    openMedicalCertificate,
    onCloseContextMenu,
    activeTab,
    pendingConsultActive,
  } = props;
  const pendingConsultActiveObject = useSelector(state =>
    getConsultById(state, pendingConsultActive),
  );
  const { latestConsult } = conversationActive || { latestConsult: null };
  const { id, status, poolStatus } = latestConsult || { id: null, status: null, poolStatus: null };

  return (
    <Segment className="messages-header">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flex: '0 1 auto',
          overflow: 'hidden',
          padding: 1, // for box-shadow
        }}>
        {isMinimize && (
          <BubbleMenu
            conversationActive={conversationActive}
            isMinimize={isMinimize}
            openPrescriptionModal={openPrescriptionModal}
            openReferralMemo={openReferralMemo}
            openMemoRandum={openMemoRandum}
            openPOS={openPOS}
            openMedicalCertificate={openMedicalCertificate}
          />
        )}
        <UserStatus
          changeContextMenu={props.changeContextMenu}
          consultId={id}
          isMinimize={isMinimize}
          poolStatus={poolStatus}
          consultStatus={status}
          consult={
            pendingConsultActive !== -1 && !isMinimize ? pendingConsultActiveObject : latestConsult
          }
        />
      </div>
      <MenuOptions
        pendingConsultActive={pendingConsultActive}
        changeContextMenu={props.changeContextMenu}
        consultId={id}
        contextMenu={contextMenu}
        consultStatus={status}
        consult={latestConsult || pendingConsultActiveObject}
        doctor={doctor}
        openFinishConsult={openFinishConsult}
        isMinimize={isMinimize}
        onClickBubble={onClickBubble}
        conversationActive={conversationActive}
        onCloseContextMenu={onCloseContextMenu}
        activeTab={activeTab}
      />
    </Segment>
  );
};

export default MessageHeader;
